import { render } from "./NewBuyerView.vue?vue&type=template&id=fdc4cf48"
import script from "./NewBuyerView.vue?vue&type=script&lang=js"
export * from "./NewBuyerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__